'use strict';

module.exports = {
    EXECUTION: 'execution',
    FORECASTING: 'forecasting',
    INTOOL: 'inTool',
};
